import styled from 'styled-components';

import { Button } from '@riac/design-system';
import { Select, SelectDropDownIcon, SelectLabel } from '@riac/design-system';

export const PaginationContainer = styled.div`
  @media print {
    display: none;
  }
  background-color: ${(props) => props.theme.black[10]};
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  display: grid;
  grid-template-columns: 1fr auto;
  font-size: 1.6rem;

  /* ${(props) => props.theme.tablet} {
    grid-template-columns: 1fr 1fr;
  } */

  /* @media screen and (min-width: 1280px) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  } */
`;

export interface ICollapse {
  show: boolean;
  ht?: number;
}

export const CollapsePaginationContainer = styled.div<ICollapse>`
  @media print {
    display: none;
  }
  z-index: 10;
  background-color: ${(props) => props.theme.black[10]};
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  display: grid;
  grid-template-columns: 1fr;
  font-size: 1.6rem;

  max-height: 0;
  /* overflow: hidden; */
  transition: all 500ms;

  ${(props) => props.show && `
    max-height: 153px;
  `}
  > div {
    ${(props) => props.show && `
      max-height: 153px;
    `}
  }
`;

export const CollapseButton = styled(Button)`
  height: 50px;
  width: 50px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: center;
`;

interface IPaginationSection {
  width?: number;
}

export const CollapseButtonSection = styled.div`
  height: 50px;
  width: 50px;
  color: ${(props) => props.theme.black[90]};
  background-color: ${(props) => props.theme.black[10]};
  flex: 1 1 100%;
  justify-content: center;
  ${(props) => props.theme.phone} {
    flex: 1;
  }
  
  display: flex;
  align-items: center;
  &:hover {
    background-color: ${(props) => props.theme.black[30]};
  }

  cursor: pointer;
`;

export const PaginationSection = styled.span<IPaginationSection>`
  margin: 0px;
  margin-left: 10px;
  margin-right: 0px;
  color: ${(props) => props.theme.black[90]};
  flex: 1 1 100%;
  ${(props) => props.theme.phone} {
    flex: 1;
    margin-left: 25px;
  }

  label {
    white-space: nowrap;
    display: flex;
    align-items: center;
    margin-bottom: 0px;
    margin-top: 0px;
    span {
        min-width: 70px;
    }

    > div {
      margin-left: 0px;
      border-left: 1px solid ${(props) => props.theme.black[30]};
      border-right: 1px solid ${(props) => props.theme.black[30]};

      ${(props) => props.theme.phone} {
        width: ${(props) => props.width}px;
      }

      div {
        border: none;
        font-size: 1.8rem;
      }
    }
  }
  
  .react-select {
    flex: 1;
  }
  display: flex;
  align-items: center;
`;

export const PageArrow = styled(Button)`
  svg {
    vertical-align: middle;
  }
  &:disabled {
    background: ${(props) => props.theme.black[10]};
    svg {
      color: ${(props) => props.theme.black[20]};
    }
  }

  font-size: 2.4rem;
  color: ${(props) => props.theme.black[90]};
  padding: 12px;
  margin-right: 10px;
  transition: none;
  
  &:hover {
    color: ${(props) => props.theme.gold[50]};
  }
`;

export const PaginationSelect = styled(Select)`
  gap: 0;
  align-items: stretch;
  
  ${SelectLabel} {
    display: flex;
    align-items: center;
    min-width: 70px;
    border-right: solid 1px ${(props) => props.theme.black[30]};
  }
  
  &&& ${SelectDropDownIcon} {
    color: ${(props) => props.theme.black[30]};
  }
`;
